import en from './forceUpdateStrings.en';

export default {
  en,
};
